import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})
export class SBoardService {

  constructor(
    private restful: RestfulService,
  ) { }

  private extractData(res: Response) {
    let body = res;
    return body || [ ];
  }

  private handleErrorPromise(error: Response | any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }

  // 게시판 정보 리스트 가져오기
  getBoardInfoId(board_id): Promise<any> {
    return this.restful.get({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'getBoardInfoId'
      }, {
        board_id: board_id
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 게시글 정보 가져오기
  getBoardView(board_id, board_seq, view_check ): Promise<any> {
    return this.restful.get({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'getBoardView'
      }, {
        board_id: board_id,
        board_seq: board_seq,
        view_check: view_check
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 게시글 정보 가져오기
  getBoardViewIndex(board_id, board_index ): Promise<any> {
    return this.restful.get({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'getBoardViewIndex'
      }, {
        board_id: board_id,
        board_index: board_index
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 게시글 저장
  setWrite( form ): Promise<any> {
    return this.restful.post({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'setWrite'
      }, form.value
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 게시판 리스트 가져오기
  getBoardList( params ): Promise<any> {
    return this.restful.get({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'getBoardList'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 견적요청 리스트 가져오기
  getEstimateList( params ): Promise<any> {
    return this.restful.get({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'getEstimateList'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 견적요청 저장
  setEstimateSave( form ): Promise<any> {
    return this.restful.post({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'setEstimateSave'
      }, form.value
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 메인 게시판 리스트 가져오기
  getBoardMainList(): Promise<any> {
    return this.restful.get({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'getBoardMainList'
      }, {}
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 메인 게시판 리스트 가져오기
  getBoardListLimit( params ): Promise<any> {
    return this.restful.get({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'getBoardListLimit'
      }, params
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 게시글 삭제
  deleteBoard( board_id, board_seq ): Promise<any> {
    return this.restful.get({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'deleteBoard'
      }, {
        board_id: board_id,
        board_seq: board_seq
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 게시글 첨부파일 삭제
  deleteUploadFile( board_id, board_seq, seq ): Promise<any> {
    return this.restful.get({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'deleteUploadFile'
      }, {
        board_id: board_id,
        board_seq: board_seq,
        seq: seq
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 메인 베너 리스트 가져오기
  getBannerList(): Promise<any> {
    return this.restful.get({
        program: 'shop',
        service: 'board',
        version: '1.0',
        action: 'getBannerList'
      }, {}
    ).then(this.extractData)
      .catch(this.handleErrorPromise);
  }

}
